import { create } from 'zustand';

/**
 * Global Power Dialer state.
 * Lives outside of React component tree so it persists across CRM page navigations.
 * Progress is saved per pipeline so switching pipelines doesn't mix up state.
 */
export const usePowerDialerStore = create((set, get) => ({
	active: false,
	queue: [],
	currentIndex: 0,
	pipelineId: null,
	minimized: false,

	// Map of pipelineId → lastStoppedIndex
	stoppedAt: {},

	start: (queue, pipelineId, fromIndex = 0) =>
		set({
			active: true,
			queue,
			currentIndex: fromIndex,
			pipelineId,
			minimized: false,
		}),

	stop: () => {
		const { pipelineId, currentIndex } = get();
		set((s) => ({
			active: false,
			minimized: false,
			stoppedAt: pipelineId ? { ...s.stoppedAt, [pipelineId]: currentIndex } : s.stoppedAt,
		}));
	},

	next: () => set((s) => ({ currentIndex: s.currentIndex + 1 })),

	minimize: () => set({ minimized: true }),
	restore: () => set({ minimized: false }),

	getStoppedIndex: (pipelineId) => get().stoppedAt[pipelineId] ?? null,

	clearHistory: (pipelineId) =>
		set((s) => {
			const next = { ...s.stoppedAt };
			delete next[pipelineId];
			return { stoppedAt: next };
		}),
}));
